import Modal from 'react-bootstrap/Modal';
import React, { useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';
import FormCheck from 'react-bootstrap/FormCheck';
import FormCheckLabel from 'react-bootstrap/esm/FormCheckLabel';
import { useNavigate } from 'react-router-dom';
import { api } from '../../services/api';
import { AxiosError } from 'axios';
import Loading from 'components/common/Loading';
// import Button from 'react-bootstrap/Button';
// import Modal from 'react-bootstrap/Modal';
// import TermOfServiceModal from '../login/TermOfServiceModal';
import { numberWithCommas } from '../../utils/commonUtils';
// import { ActiveCoinItems } from './type_types';
import { BASE_IMG_URL } from 'const/ConstBase';
import paths from 'router/paths';

import './ShopBody.scss';

export const ShopBody = () => {
    const nav = useNavigate();
    const [balance, setBalance] = React.useState(0);
    const [agree, setAgree] = useState(false);
    const [isModalShow, setModalShow] = React.useState(false);
    const [loading, setLoading] = useState(false);
    const [widgetUrl, setWidgetUrl] = useState('');
    const [showOverlay, setShowOverlay] = useState(true);

    const shopItems = [
        {
            id: 1,
            name: '500 RC',
            value: 'p500',
        },
        {
            id: 2,
            name: '1030 RC',
            value: 'p1000',
        },
        {
            id: 3,
            name: '3150 RC',
            value: 'p3000',
        },
        {
            id: 4,
            name: '5350 RC',
            value: 'p5000',
        },
        {
            id: 5,
            name: '11000 RC',
            value: 'p10000',
        },
    ];

    async function getBalance() {
        try {
            const response = await api.post('/account/balance');
            return response.data;
        } catch (error) {
            return error as AxiosError;
        }
    }
    async function getPurchaseWidget(id: string) {
        try {
            const response = await api.post('/shop/widget', { itemId: id });
            return response.data;
        } catch (error) {
            return error as AxiosError;
        }
    }

    function onChangeAgree(event: React.ChangeEvent<HTMLInputElement>) {
        setAgree(event.target.checked);
        setShowOverlay(false);
    }
    // async function getActiveSaleItem() {
    //     try {
    //         const response = await api.post('/shop/sales_items');
    //         return response.data;
    //     } catch (error) {
    //         return error as AxiosError;
    //     }
    // }

    function goPurchaseHistory() {
        nav(paths.TOPUP_COIN_HISTORY_PATH);
    }

    function clickPurchase(item: string) {
        setLoading(true);
        if (!agree) {
            alert('Please check the Purchase Agreement.');
            window.location.reload();
            return;
        }
        getPurchaseWidget(item).then((res) => {
            if (res.data && res.data.result === 'OK') {
                setWidgetUrl(res.data.url);
                setModalShow(true);
            } else {
                switch (res.message) {
                    case 'BLOCK_USER':
                        alert('You are blocked.');
                        break;
                    case 'BLOCK_IP':
                        alert('Your IP is blocked.');
                        break;
                    case 'NOT_EXISTS_ITEM':
                        alert('Not exists item.');
                        break;
                    case 'NOT_EXISTS_USER':
                        alert('Not exists user.');
                        break;
                    default:
                        alert(
                            'Paymentwall is currently experiencing difficulties, please check back later'
                        );
                }
                window.location.reload();
            }
            setLoading(false);
        });
    }

    useEffect(() => {
        getBalance()
            .then((currentBalance) => {
                if (isNaN(currentBalance)) {
                    setBalance(0);
                } else {
                    setBalance(currentBalance);
                }
            })
            .catch((err) => {});

        // getActiveSaleItem()
        //     .then((res) => {
        //         if (res.data && res.data.length > 0) {
        //             setActiveSaleItem(res.data);
        //         } else {
        //             setActiveSaleItem([]);
        //         }
        //     })
        //     .catch((err) => {});
    }, []);

    // Subcomponent: CoinHistoryHeader
    const CoinHistoryHeader = ({
        balance,
        onHistoryClick,
    }: {
        balance: number;
        onHistoryClick: () => void;
    }) => (
        <div className='coin-history-header'>
            <Col md={8}>
                <div className='coin-history-button-wrapper'>
                    <span className='coin-history-label'>
                        Saldo de RC : {numberWithCommas(balance)}
                    </span>
                    <button
                        className='coin-history-button'
                        onClick={onHistoryClick}
                    >
                        Histórico de Compras
                    </button>
                </div>
            </Col>
        </div>
    );

    // Subcomponent: ShopItems
    const ShopItems = ({
        shopItems,
        onItemClick,
    }: {
        shopItems: { id: number; name: string; value: string }[];
        onItemClick: (value: string) => void;
    }) => (
        <div className='items-container'>
            {shopItems.map((item) => (
                <img
                    key={item.id}
                    className='shop-contents-items__image'
                    src={`${BASE_IMG_URL}shop_item_${item.id}.webp`}
                    alt={`item ${item.name}`}
                    onClick={() => onItemClick(item.value)}
                />
            ))}
        </div>
    );

    // Subcomponent: PurchaseAgreementOverlay
    const PurchaseAgreementOverlay = ({
        agree,
        onChangeAgree,
    }: {
        agree: boolean;
        onChangeAgree: (e: React.ChangeEvent<HTMLInputElement>) => void;
    }) => (
        <div className='shop-purchase-agreement-overlay'>
            <div className='shop-purchase-agreement'>
                <div className='shop-purchase-agreement-contents'>
                    <div className='shop-purchase-agreement-title'>
                        <FormCheck
                            id='purchase-agreement'
                            isInvalid={!agree}
                            disabled={agree}
                            onChange={onChangeAgree}
                        />
                        <FormCheckLabel
                            className='purchase-agreement-label'
                            htmlFor='purchase-agreement'
                        >
                            Concordância de Compra
                        </FormCheckLabel>
                    </div>
                    <p className='shop-purchase-agreement-description'>
                        Ao efetuar a compra, você declara que leu e concorda com
                        o EULA e todos os termos e condições publicados no site
                        relacionados ao uso do serviço. Você também reconhece
                        que, após a compra, não será possível solicitar
                        reembolso. Além disso, o comprador declara ter 13 anos
                        ou mais. Caso o comprador seja menor de idade, declara
                        que obteve o consentimento de seus pais ou responsáveis
                        legais, e compreende que toda a responsabilidade
                        decorrente recairá sobre o próprio comprador e seus
                        responsáveis.
                    </p>
                </div>
            </div>
        </div>
    );

    // Subcomponent: PurchaseModal
    const PurchaseModal = ({
        show,
        onHide,
        widgetUrl,
    }: {
        show: boolean;
        onHide: () => void;
        widgetUrl: string;
    }) => (
        <Modal
            size='lg'
            aria-labelledby='contained-modal-title-vcenter'
            centered
            backdrop={'static'}
            onHide={onHide}
            show={show}
            dialogClassName='modal-90w'
        >
            <Modal.Header closeButton>
                <Modal.Title id='contained-modal-title-vcenter'>
                    Purchase M-Coin
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <iframe
                    title='purchase-widget'
                    src={widgetUrl}
                    style={{ width: '100%', height: 700 }}
                />
            </Modal.Body>
            <Modal.Footer></Modal.Footer>
        </Modal>
    );

    return (
        <>
            <div className='shop-body-container'>
                <CoinHistoryHeader
                    balance={balance}
                    onHistoryClick={goPurchaseHistory}
                />
                <div className='shop-divider'></div>
                <div className='shop-contents-container'>
                    <p className='shop-contents-description'>
                        Ao clicar no item desejado, uma janela de compra será
                        exibida. Antes de finalizar a compra, é necessário ler e
                        concordar com as informações abaixo e marcar a opção
                        correspondente. Em caso de dúvidas sobre a compra, entre
                        em contato com o nosso suporte ao cliente.
                    </p>
                    <div className='shop-contents-items'>
                        <ShopItems
                            shopItems={shopItems}
                            onItemClick={clickPurchase}
                        />
                        {showOverlay && (
                            <PurchaseAgreementOverlay
                                agree={agree}
                                onChangeAgree={onChangeAgree}
                            />
                        )}
                        {loading ? (
                            <Loading />
                        ) : (
                            <PurchaseModal
                                show={isModalShow}
                                onHide={() => {
                                    setModalShow(false);
                                    setShowOverlay(true);
                                    setAgree(false);
                                }}
                                widgetUrl={widgetUrl}
                            />
                        )}
                    </div>
                </div>
            </div>
        </>
    );
};
